import React, {Component} from 'react';
import { getClassNames } from 'dynamic-class-list';
import './style.scss';
import { DropTarget } from 'react-dnd';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import { update_drop_target, update_active, getTargetType, getHoverType, canDrop, checkCanDrop, removeItem } from '../../Services/Drop/action';
import { addDragEmelements } from '../../Services/Drag/action';
import { Store } from '../../../src/store';
import {Types} from '../../Services/Types';
import {validation} from '../../Services/Global/validation'
import FontAwesome from 'react-fontawesome' ;

export const ItemTypes = {
    CARD: 'card'
};

function collect(connect, monitor) {
    return {
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      getItem: monitor.getItem(),
    };
}

const squareTarget = {
    drop(props, monitor, component ) {
        let item = monitor.getItem();
        Store.dispatch(update_drop_target(item.type, props.mainIndex, props.childIndex));
        /* Store.dispatch(getTargetType(item.type, props.mainTarget.types));  */
        
        
        let insertData = {
            'mainIndex': props.mainIndex,
            'childIndex': props.childIndex,
            'type': item.type,
            'rotation': 'top'
        };
        
        

        Store.dispatch(addDragEmelements(insertData));
    },
    canDrop(props, monitor, component) {
        const stateObj = Store.getState();
        let elements = stateObj.drop.droplEments;
        let item = monitor.getItem();
        //return checkingDropElements(elements, props.mainIndex, item)
        return validation(elements,props.mainIndex, item )
    },
};

class DropzoneColumnTop extends Component {
    constructor(props, context) {
		super(props, context);

        this.state = {}
    }
    remove = (mainTarget) => {
        this.props.removeItem(mainTarget.index, mainTarget.childIndex);
    }

    componentDidUpdate = () => {

    }
    render = () => {
        const {connectDropTarget, isOver, canDrop, getItem, mainTarget, targethover, dropElements} = this.props;
        let appendTarget = "";
        
            if(mainTarget.item)
            {
                
                switch(mainTarget.item) {
                    case Types.ONE: 
                        appendTarget =  (
                            <div className="line-container"   style={{width: "170px", marginLeft: '-6px', zIndex: '99'}}>
                                <div className="line-settings">
                                    <button className="button" onClick={() => this.remove(mainTarget)} >
                                        <span className="icon">
                                        <FontAwesome name='trash' size='2x' />
                                        </span>
                                        <span>Ta bort</span>
                                    </button>
                                </div>
                                <div className="topline"></div>
                            </div>
                        )//<DropzonePreview image="/grund_sektion.svg" name="GRUNDSEKTION - 2 M" />
                    break;
                    case Types.TWO: 
                        appendTarget = (
                            <div className="line-container"   style={{width: "170px", marginLeft: '-6px', zIndex: '99'}}>
                                <div className="line-settings">
                                    <button className="button" onClick={() => this.remove(mainTarget)} >
                                        <span className="icon">
                                        <FontAwesome name='trash' size='2x' />
                                        </span>
                                        <span>Ta bort</span>
                                    </button>
                                </div>
                                <div className="topline blue" ></div>
                            </div>
                        )
                    break;
                    case Types.THREE: 
                    appendTarget = (
                        <div className="line-container"   style={{width: "90px", marginLeft: '-6px', zIndex: '99'}}>
                            <div className="line-settings">
                                <button className="button" onClick={() => this.remove(mainTarget)} >
                                    <span className="icon">
                                    <FontAwesome name='trash' size='2x' />
                                    </span>
                                    <span>Ta bort</span>
                                </button>
                            </div>
                            <div className="topline" ></div>
                        </div>
                    )
                    break;
                    case Types.FOUR: 
                        appendTarget = (
                            <div className="line-container"   style={{width: "90px", marginLeft: '-6px', zIndex: '99'}}>
                                <div className="line-settings">
                                    <button className="button" onClick={() => this.remove(mainTarget)} >
                                        <span className="icon">
                                        <FontAwesome name='trash' size='2x' />
                                        </span>
                                        <span>Ta bort</span>
                                    </button>
                                </div>
                                <div className="topline blue" ></div>
                            </div>
                        )
                    break;  
                    default: 

                }
                
            }

        if(isOver && canDrop)
        {
            // console.log('over');
            var dropZonesStyle = getClassNames({
                'top': function() {
                    return true
                },
                'top-2': function() {
                    
                    switch(getItem.type)
                    {
                        case Types.ONE:
                            return true;
                        case Types.TWO:
                            return true;
                        default: 
                            return false;
                    }
                },
                'over': function() {
                    return true;
                }
            });
        } else if(isOver && !canDrop) {
            var dropZonesStyle = getClassNames({
                'top': function() {
                    return true
                },
                'top-2': function() { 
                    switch(getItem.type)
                    {
                        case Types.ONE:
                            return true;
                        case Types.TWO:
                            return true;
                        default: 
                            return false;
                    }
                },
                'red': function() {
                    return true;
                }
            });
        } else {
            var dropZonesStyle = getClassNames({
                'top': function() {
                    return true
                },
                'over': function() {
                    return false;
                },
            });
        }
        return connectDropTarget (
            <div className={dropZonesStyle}>{appendTarget}</div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        dropElements: state.drop.droplEments,
        targethover: state.drop.targethover
    };
};
const mapDispatchToProps = (dispatch) => {
  return {

    update_drop_target: bindActionCreators(update_drop_target, dispatch),
    update_active: bindActionCreators(update_active, dispatch),
    getTargetType: bindActionCreators(getTargetType, dispatch),
    addDragEmelements: bindActionCreators(addDragEmelements, dispatch),
    getHoverType: bindActionCreators(getHoverType, dispatch),
    canDrop: bindActionCreators(canDrop, dispatch),
    removeItem: bindActionCreators(removeItem, dispatch)

  };
}; 

DropzoneColumnTop = DropTarget(ItemTypes.CARD, squareTarget, collect)(DropzoneColumnTop);
export default connect(mapStateToProps, mapDispatchToProps)(DropzoneColumnTop);


// WEBPACK FOOTER //
// ./src/Components/DropzoneColumnTop/index.js